import { EventEmitter, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
var ConfirmDeleteNewSchedulingSuggestionsComponent = /** @class */ (function () {
    function ConfirmDeleteNewSchedulingSuggestionsComponent(data, matDialogRef) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.isLoading = new EventEmitter();
        this.form = this.data;
    }
    ConfirmDeleteNewSchedulingSuggestionsComponent.prototype.ngOnInit = function () {
        this.scheduleSuggestionsFormArray = this.form.get('scheduleSuggestions');
    };
    ConfirmDeleteNewSchedulingSuggestionsComponent.prototype.closeDialog = function () {
        this.matDialogRef.close(true);
    };
    ConfirmDeleteNewSchedulingSuggestionsComponent.prototype.deleteAllSchedulingSuggestions = function () {
        this.isLoading.emit(true);
        this.scheduleSuggestionsFormArray.clear();
        if (this.form.get('companyScheduleSuggestion') && this.form.get('companyScheduleSuggestion').value) {
            this.form.get('scheduleSuggestionsStatus').setValue('standardSuggested');
        }
        if (this.form.get('scheduleSuggestionsStatus') && this.form.get('scheduleSuggestionsStatus').value === 'newScheduleSuggestion') {
            this.form.get('scheduleSuggestionsStatus').setValue(null);
        }
        if (this.form.get('scheduleSuggestionsWasChanged')) {
            this.form.get('scheduleSuggestionsWasChanged').setValue(true);
        }
        this.closeDialog();
        this.isLoading.emit(false);
    };
    return ConfirmDeleteNewSchedulingSuggestionsComponent;
}());
export { ConfirmDeleteNewSchedulingSuggestionsComponent };
